import React from 'react';

const Footer = () => {
return (
    <footer className="footer-admin">
        <div className="container text-center">
            <p className="dark text-primary-dark">© 2025 Partidul România Dreaptă și Prosperă. Toate drepturile rezervate.</p>
            <p className="dark text-primary-dark mt-3 mb-5">Powered by <a href="https://joinstack.tech" className="brand-footer">Joinstack Technology</a></p>
        </div>
    </footer>
)
};

export default Footer;